import React, { useState } from "react";
import { Link } from "react-router-dom";

const PreferencesNav = () => {
  const [active, setActive] = useState("salesOrder"); 

  const handleChangeOption = (data) => {
    setActive(data);
  };

  return (
    <>
      <div style={{ border: 0, paddingLeft: 15 }}>
        <h3 className="font-size-15" style={{ fontWeight: 600 }}>SETTINGS</h3>
      </div>

      <div
        className="px-3 font-custom scroll-y noscroll-x fill body scrollbox set-list"
        
      >
        <div className="reports-group lpane-grp">
          <ul className="nav nav-pills flex-column">
            <li>
              <h4 className="mt-3">Organization</h4>
            </li>
            <li
              className="nav-item text-open"
              onChange={(e) => handleChangeOption("Organization")}
              style={{ border: 0, cursor: "pointer" }}
            >
              <Link
                to={"/settings/preferences/Organization"}
                id="ember699"
                className="ember-view nav-link"
              >
                Organization
              </Link>
            </li>
            <li
              className="nav-item text-open"
              onChange={(e) => handleChangeOption("Warehouses")}
              style={{ border: 0, cursor: "pointer" }}
            >
              <Link
                to={"/settings/Preferences/Warehouses"}
                id="ember699"
                className="ember-view nav-link"
              >
                Warehouses
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/store"}
                id="ember699"
                className="ember-view nav-link"
              >
                Store
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/rack"}
                id="ember699"
                className="ember-view nav-link"
              >
                Rack
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/cell"}
                id="ember699"
                className="ember-view nav-link"
              >
                Cell/Floor
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/pallet"}
                id="ember699"
                className="ember-view nav-link"
              >
                Pallet
              </Link>
            </li>
            <li
              className="nav-item text-open"
              onChange={(e) => handleChangeOption("Department")}
              style={{ border: 0, cursor: "pointer" }}
            >
              <Link
                to={"/settings/preferences/DepartmentList"}
                id="ember699"
                className="ember-view nav-link"
              >
                Department{" "}
              </Link>
            </li>

            <li className="mt-3">
              <h4 className="mt-3">Categories</h4>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/customer-categories"}
                id="ember699"
                className="ember-view nav-link"
              >
                Customer Categories
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/vendor-categories"}
                id="ember699"
                className="ember-view nav-link"
              >
                Vendor Categories
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/categories"}
                id="ember699"
                className="ember-view nav-link"
              >
                Item Categories
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/sub-categories"}
                id="ember699"
                className="ember-view nav-link"
              >
                Item Sub Categories
              </Link>
            </li>

            <li className="mt-4">
              <h4>Users And Roles</h4>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/DefaultUrlList"}
                id="ember699"
                className="ember-view nav-link"
              >
                Default Roles
              </Link>
            </li>
            <li
              className="nav-item text-open"
              onChange={(e) => handleChangeOption("User Roles")}
              style={{ border: 0, cursor: "pointer" }}
            >
              <Link
                to={"/settings/Preferences/UserAndRoles"}
                id="ember699"
                className="ember-view nav-link"
              >
                User Roles
              </Link>
            </li>
            <li
              className="nav-item text-open"
              style={{ border: 0, cursor: "pointer" }}
            >
              <Link
                to={"/settings/preferences/DeliveryPersonList"}
                id="ember699"
                className="ember-view nav-link"
              >
                Delivery Person
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/salesperson"}
                id="ember699"
                className="ember-view nav-link"
              >
                Salesperson
              </Link>
            </li>

            <li className="mt-4">
              <h4>Taxes</h4>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/HSN"}
                id="ember699"
                className="ember-view nav-link"
              >
                HSN
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/quality-parameter"}
                id="ember699"
                className="ember-view nav-link"
              >
                Quality Parameter
              </Link>
            </li>
            <li
              className="nav-item text-open"
              onChange={(e) => handleChangeOption("Taxes")}
              style={{ border: 0, cursor: "pointer" }}
            >
              <Link
                to={"/settings/Preferences/TaxList"}
                id="ember699"
                className="ember-view nav-link"
              >
                Taxes
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/TaxExempt"}
                id="ember699"
                className="ember-view nav-link"
              >
                Tax Exemption
              </Link>
            </li>

            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/TDS"}
                id="ember699"
                className="ember-view nav-link"
              >
                TDS
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/tcs-rate"}
                id="ember699"
                className="ember-view nav-link"
              >
                TCS
              </Link>
            </li>

            <li>
              <h4 className="mt-4">Terms</h4>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/TermsConditionList"}
                id="ember699"
                className="ember-view nav-link"
              >
                Terms Condition
              </Link>
            </li>
            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/PaymentTerms"}
                id="ember699"
                className="ember-view nav-link"
              >
                Payment Terms
              </Link>
            </li>

            <li className="text-open" style={{ border: 0, cursor: "pointer" }}>
              <Link
                to={"/settings/preferences/UnitList"}
                id="ember699"
                className="ember-view nav-link"
              >
                Units
              </Link>
            </li>
          
          </ul>
        </div>
      </div>
    </>
  );
};

export default PreferencesNav;
